import logo from "../../oversight-core/assets/images/chloride-exide.svg";

const Logo = () => {
  return <img src={logo} alt="oversight_logo" />;
};

export default Logo;
